

export const activityTypes = [
  { id: 1, name: 'Missie' },
  { id: 2, name: 'Extra Games' },
  { id: 3, name: 'Mediaquiz' }
]
